import { SxProps, Theme } from '@mui/material';
import { getVisibleScrollbarStyles } from 'components/Table/visibleScrollbarStyles';
import { TableHorizontalScroll } from '../hooks/useTableHorizontalScroll';

const FADE_WIDTH_PX = 48;

const fade = ({
  areaTop,
  areaHeight,
  canScrollRight
}: TableHorizontalScroll): SxProps<Theme> => ({
  position: 'absolute',
  right: 0,
  top: areaTop,
  height: areaHeight,
  width: FADE_WIDTH_PX,
  pointerEvents: 'none',
  zIndex: 1,
  opacity: canScrollRight ? 1 : 0,
  transition: 'opacity 150ms',
  background: (theme) =>
    `linear-gradient(to right, transparent, ${theme.palette.white})`
});

const STICKY_BAR_INSET_PX = 8;

const stickyScrollbar =
  ({ screenLeft, screenWidth }: TableHorizontalScroll): SxProps<Theme> =>
  (theme) => ({
    ...getVisibleScrollbarStyles(theme.palette),
    position: 'fixed',
    // Above the bottom action bar when one is open, as on the candidate search.
    bottom: `calc(var(--popp-action-bar-height, 0px) + ${STICKY_BAR_INSET_PX}px)`,
    left: screenLeft,
    width: screenWidth,
    overflowX: 'auto',
    overflowY: 'hidden',
    zIndex: 2,
    // Opaque, and the shadow fills the inset below, or rows show through
    // both, as on the candidate search table.
    backgroundColor: theme.palette.common.white,
    boxShadow: `0 ${STICKY_BAR_INSET_PX}px 0 0 ${theme.palette.common.white}`
  });

const stickyScrollbarTrack = ({
  scrollWidth
}: TableHorizontalScroll): SxProps<Theme> => ({
  width: scrollWidth,
  height: '1px'
});

export const tableScrollAffordancesSx = {
  fade,
  stickyScrollbar,
  stickyScrollbarTrack
};
